import { ConfirmDialog } from '@shigo-ui/ui';

import { dashboardT } from '../../lib/messages';

/** Asks before throwing away unsaved form edits (dialog close, route leave). */
export function DiscardChangesDialog({
  open,
  onStay,
  onDiscard,
}: {
  open: boolean;
  onStay: () => void;
  onDiscard: () => void;
}) {
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onStay();
      }}
      title={dashboardT('forms.unsavedChanges.title')}
      description={dashboardT('forms.unsavedChanges.description')}
      cancelLabel={dashboardT('forms.unsavedChanges.stay')}
      confirmLabel={dashboardT('forms.unsavedChanges.discard')}
      destructive
      onConfirm={onDiscard}
    />
  );
}
